module.exports = __webpack_public_path__ + "944f2e17ad971b3b72ec8350f670e21f.pdf";